import { ConfigContext } from "../config_context";
import { useContext } from 'react';
import "./img.css";

export function PanelImg(props: {src: string}){
    const base_asset_url = useContext(ConfigContext).base_asset_url;
    return <img className="panel_img" src={base_asset_url+props.src}/>
}